import { useState } from "react";
import { HolidayEvent } from "../../pages/calendar";
import SvgIcon from "../icons";
import "./style.css";
import { useUserInfo } from "../../context/user";
import { useGenerateImageFinal, useGenerateChatContent, usePostOnGhl } from "../../queries/calendar";
import Twiterimg from "./X.svg"
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

interface DayProps {
  date: Date;
  events: HolidayEvent[];
  socialopt: { name: string; description: string }[];
  tonesopt: { name: string; description: string }[];
  translateopt: { name: string; description: string }[];
  imagesoption: { name: string; description: string }[];
  SMAccoutns: {
    avatar: string,
    deleted: boolean,
    expire: string,
    id: string,
    isExpired: boolean,
    name: string,
    oauthId: string,
    platform: string,
    profileId: string,
    type: string
  }[];
  agency: {
    _id: string
  }
}
interface MyObject {
  [key: string]: any; // Index signature allowing any property key with any value type
}
interface Item {
  name: string;
  image: string;
  description: string;
}

export const Day: React.FC<DayProps> = ({ date, events, socialopt, tonesopt, translateopt, imagesoption, SMAccoutns, agency }) => {
  const postOnGhlMutation = usePostOnGhl();
  const userInfo = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const checkIfGhlUser = useUserInfo()[9];

  const [loadingEventTitles, setLoadingEventTitles] = useState<{ [key: string]: boolean }>({});
  const [eventContent, setEventContent] = useState<{
    [key: string]: string | null | any;
  }>({});
  const [tooltipStates, setTooltipStates] = useState<any>({});
  const [LoaderContent, setLoaderContent] = useState([
    { index: false, value: 'Writing Social Post' },
    { index: false, value: 'Editing post' },
    { index: false, value: 'Translating post' },
    { index: false, value: 'Creating image' },
  ]);
  const [showTooltip, setShowTooltip] = useState<number | null>(null);
  const [isImagePrompt, setIsImagePrompt] = useState<boolean[]>([]); // Explicitly typed as an array of booleans
  // const [isImagerevisedpropmpt, setIsImagerevisedpropmpt] = useState("");
  const [imageUrl, setImageUrl] = useState<any>();
  const [lastresponse, setLastResponse] = useState<MyObject[]>([])
  const [promptlast, setPromptlast] = useState<MyObject[]>([]);
  const [promptlastactive, setPromptlastactive] = useState<MyObject[]>([]);
  const [selecteditem, setSelecteditem] = useState<MyObject[]>([]);
  const [Relatedpost, setRelatedpost] = useState<Item[]>([]);
  const [trnslateon, settrnslateon] = useState<Item[]>([]);
  const [highlitnav, sethighlitnav] = useState<MyObject[]>([]);
  const [showDropDown, setShowDropDown] = useState(false);
  const [showDropDown1, setShowDropDown1] = useState(false);
  const [showDropDown2, setShowDropDown2] = useState(false);
  const [showDropDown3, setShowDropDown3] = useState(false);
  const [showDropDown4, setShowDropDown4] = useState(false);
  const [RefreshPostModal, setRefreshPostModal] = useState(false);
  const [RefreshPostModaldata, setRefreshPostModaldata] = useState<any>({});
  const [eventImages, setEventImages] = useState<any>([]);

  const { mutateAsync: generateImageFinal } = useGenerateImageFinal();
  const { mutateAsync: generateChatContent } = useGenerateChatContent();
  const dayOfWeek = date.toLocaleString("en-US", { weekday: "short" });
  var dayOfMonth = date.getDate();
  const loc_id = userActiveLocation?.id;
  const name = userInfo?.userName;
  const email = userInfo?.email;
  const currentDate = new Date().getDate();
  const [celenderdate, setcelenderdate] = useState<any>([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ]);


  const handleSelect = (ranges: any) => {
    setcelenderdate([ranges.selection]);

  };


  const handleRequest = (item: any, title: string, date: string, index: number) => {


    setShowDropDown(false);
    setShowDropDown1(false);
    setShowDropDown2(false);
    setShowDropDown3(false);
    var regen_request = true;
    if (loadingEventTitles[title]) {
      return;
    }
    setLoadingEventTitles((prevLoadingEventTitles) => ({
      ...prevLoadingEventTitles,
      [title]: true,
    }));
    var replacedDescription = '';
    if (item === 'image') {
      replacedDescription = `suggest an AI prompt that could be used to generate a suitable image to accompany a social media post about ${title}.`;
      setIsImagePrompt((prevState) => {
        const updatedIsImagePrompt = [...prevState]; // Create a copy of the array
        updatedIsImagePrompt[index] = true; // Set the value to true for the specified index
        return updatedIsImagePrompt; // Return the updated array to update the state
      });
    }
    else {
      setIsImagePrompt((prevState) => {
        const updatedIsImagePrompt = [...prevState]; // Create a copy of the array
        updatedIsImagePrompt[index] = false; // Set the value to true for the specified index
        return updatedIsImagePrompt; // Return the updated array to update the state
      });
      // check for store  post creating type;
      var checkofpostwrting = "";
      if (imagesoption.map((option: any) => option.name).includes(item.name)) {
        checkofpostwrting = "imgpost";
      }
      if (tonesopt.map((option: any) => option.name).includes(item.name)) {
        checkofpostwrting = "tonepost";
      }
      if (translateopt.map((option: any) => option.name).includes(item.name)) {
        checkofpostwrting = "transpost";
      }
      if (socialopt.map((option: any) => option.name).includes(item.name)) {
        checkofpostwrting = "socialpost";
      }
      // check for store  post creating type;
      if (!imagesoption.map((option: any) => option.name).includes(item.name)) {
        // setIsImagerevisedpropmpt("")
        regen_request = false;
      }
      const placeholderRegex = /(?:\{|\[)([^}\]]+)(?:\}|\])/g;
      const itemDescription = item.description;
      var awarenessDay = title; // Assuming 'title' holds the awareness day value
      var platformsdata = item.name; // Assuming 'platform' holds the platform value
      var descdata = item.description; // Assuming 'platform' holds the platform value
      replacedDescription = itemDescription.replace(placeholderRegex, (match: any, placeholder: any) => {
        switch (placeholder) {
          case "awareness day":
            return awarenessDay;
          case "platform":
            return platformsdata;
          case "post copy":
            //bug found her
            return eventContent[title].includes("https://statictemp") ? lastresponse : eventContent[title];
          case "target language":
            return platformsdata;
          case "Art Style":
            return platformsdata;
          default:
            return match;
        }
      });
    }
    setPromptlast((prevState) => {
      const select = [...prevState];
      if (!select[index]) {
        select[index] = {};
      }
      select[index]["socialpost"] = lastresponse[index] ? lastresponse[index]["socialpost"] : null;
      select[index]["tonepost"] = lastresponse[index] ? lastresponse[index]["tonepost"] : null;
      select[index]["transpost"] = lastresponse[index] ? lastresponse[index]["transpost"] : null;
      select[index]["imgpost"] = lastresponse[index] ? lastresponse[index]["imgpost"] : null;
      return select;
    });
    // /trigger direct image if found revised prompt 
    if (regen_request === true) {
      generateImageFinal({
        prompt: replacedDescription,
        image: item === 'image' ? true : false,
        profile_id: loc_id,
      }).then((responsea: any) => {
          setIsImagePrompt((prevState: any) => {
            const updatedIsImagePrompt = [...prevState]; // Create a copy of the array
            updatedIsImagePrompt[index] = true; // Set the value to true for the specified index
            return updatedIsImagePrompt; // Return the updated array to update the state
          });
          setEventContent((prevContent: any) => ({
            ...prevContent,
            [title]: responsea.data.url,
          }));
          setImageUrl(responsea.data.url)
          // if (responsea?.data?.revised_prompt) {
          //   setIsImagerevisedpropmpt(responsea.data.revised_prompt)
          // }
          setLoadingEventTitles((prevLoadingEventTitles: any) => ({
            ...prevLoadingEventTitles,
            [title]: false,
          }));

        }).catch(() => {
          // Preserved from the old useHttp-based call: a failed request left
          // loadingEventTitles stuck true rather than surfacing an error UI.
        });

      return true;
    }
    generateChatContent({
      promt: replacedDescription,
      image: lastresponse[index]?.imgpost,
      // date: date,
      // event_title: title,
      profile_id: loc_id,
      // user_name: name,
    }).then((response: any) => {
        if (item === 'image') {
          setEventContent((prevContent) => ({
            ...prevContent,
            [title]: response.data.url,
          }));
          setImageUrl(response.data.url)
          // if (response.data.revised_prompt) {
          //   setIsImagerevisedpropmpt(response.data.revised_prompt)
          // }
        } else {
          setEventContent((prevContent) => ({
            ...prevContent,
            [title]: response.data,
          }));
        }

        setLoadingEventTitles((prevLoadingEventTitles) => ({
          ...prevLoadingEventTitles,
          [title]: false,
        }));
        setLastResponse((prevState) => {
          const select = [...prevState];
          if (!select[index]) {
            select[index] = {};
          }
          select[index][checkofpostwrting] = response.data;
          return select;
        });


      }).catch(() => {
        // Preserved from the old useHttp-based call: a failed request left
        // loadingEventTitles stuck true rather than surfacing an error UI.
      });
  };

  const updateEventImage = (title: string, newImage: any) => {
    setEventImages((prevImages: any) => {
      // Check if the key (title) already exists in the array
      const index = prevImages.findIndex((image: any) => Object.keys(image)[0] === title);

      if (index !== -1) {
        // Key exists: update the value
        const updatedImages = [...prevImages];
        updatedImages[index] = { [title]: newImage };
        return updatedImages;
      } else {
        // Key does not exist: add new key-value pair
        return [...prevImages, { [title]: newImage }];
      }
    });
  };

  //only for image request 
  const handleRequestfirstloadimageonly = (loadercontent: any, dropdownvalue: any, title: string, date: string, index: number) => {
    setShowDropDown(false);
    setShowDropDown1(false);
    setShowDropDown2(false);
    setShowDropDown3(false);
    setSelecteditem((prevState) => {
      const select = [...prevState];
      select[index] = dropdownvalue;
      return select;
    });
    setLoaderContent((prevLoaderContent) => {
      const updatedContent = [...prevLoaderContent]; // Create a copy of the previous state array
      updatedContent[index] = { index: true, value: loadercontent }; // Update the specific element at the given index
      return updatedContent; // Return the updated array to setLoaderContent
    });

    setLoadingEventTitles((prevLoadingEventTitles) => ({
      ...prevLoadingEventTitles,
      [title]: true,
    }));
    var replacedDescription = '';
    replacedDescription = `Create an image in the style of ${dropdownvalue.name} to accompany a social media post about ${title}. Ensure the image reflects the theme and tone of the event in an engaging and visually appealing way.`;

    let msg_data = JSON.stringify({
      conversation_id: 'oKPIwlHo1fIK1gr7nWMesp0f',
      profile_id: loc_id,
      user_name: 'calendar',
      prompt: replacedDescription,
      assistant_model_name: 'openai/gpt-4o',
      assistant_id: userActiveLocation?.assistant_id,
    });
    // getEventContent(
    //   {
    //     url: `${BASE_URL}/chat/message`,
    //     method: "POST",
    //     payload: {
    //       data: msg_data,
    //       defualtModel: 'openai/gpt-4o',
    //       messagetype: 'notimage',
    //       prompt: replacedDescription,
    //       agency_id: agency?._id


    //       // prompt: replacedDescription,
    //       // image: true,
    //       // profile_id: loc_id,
    //     },
    //   },
    //   (responsea: any) => {
    // setIsImagerevisedpropmpt(replacedDescription)
    generateImageFinal({
      prompt: replacedDescription,
      image: false,
      profile_id: loc_id,
    }).then((responseas: any) => {
        setEventContent((prevContent) => ({
          ...prevContent,
          [title]: responseas.data.url,
        }));
        setImageUrl(responseas.data.url)
        // if (responseas.data.revised_prompt) {
        //   setIsImagerevisedpropmpt(responseas.data.revised_prompt)
        // }
        setLoadingEventTitles((prevLoadingEventTitles) => ({
          ...prevLoadingEventTitles,
          [title]: false,
        }));
        setLastResponse((prevState) => {
          const select = [...prevState];
          if (!select[index]) {
            select[index] = {};
          }
          select[index]["imgpost"] = responseas.data.url;
          return select;
        });
        updateEventImage(title, responseas.data.url)
      }).catch(() => {
        // Preserved from the old useHttp-based call: a failed request left
        // loadingEventTitles stuck true rather than surfacing an error UI.
      });
    // }
    // )
    setIsImagePrompt((prevState) => {
      const updatedIsImagePrompt = [...prevState]; // Create a copy of the array
      updatedIsImagePrompt[index] = true; // Set the value to true for the specified index
      return updatedIsImagePrompt; // Return the updated array to update the state
    });


  };
  const copyEventContent = (content: string | null, eventIndex: number) => {
    if (content == null) return false;
    const tempEl = document.createElement("div");
    tempEl.innerHTML = content;

    // Append the temporary element to the body
    document.body.appendChild(tempEl);

    // Create a range and select the content of the temporary element
    const range = document.createRange();
    range.selectNodeContents(tempEl);

    // Remove any current selections and add the new range
    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range);

    // Copy the selected content to the clipboard
    try {
      document.execCommand("copy");
      setTooltipStates((prevStates: any) => ({
        ...prevStates,
        [eventIndex]: "Copied!",
      }));
    } catch (err) {
      console.error("Failed to copy: ", err);
    }

    // Clear the selection and remove the temporary element
    selection?.removeAllRanges();
    tempEl.remove();

    setTimeout(() => {
      setTooltipStates((prevStates: any) => ({
        ...prevStates,
        [eventIndex]: "Copy!",
      }));
    }, 1500);
    setRefreshPostModal(false)
  };
  const handleBoxClickforModal = (lodercontent: any, item: any, title: string, date: string, index: number) => {
    if (lodercontent === "Writing Social Post" && lastresponse[index]) {
      setRefreshPostModal(true)
      const copyresponse = lastresponse[index].socialpost;
      setRefreshPostModaldata({ lodercontent, item, copyresponse, title, date, index })
    } else {
      handleBoxClick(lodercontent, item, title, date, index)
    }

  }
  const [openimginfoModal, setopenimginfoModal] = useState(false);
  const handleBoxClick = (lodercontent: any, item: any, title: string, date: string, index: number) => {
    // if (!lastresponse[index]?.imgpost && item.name.toLowerCase() === "instagram") {
    //   setopenimginfoModal(true)
    //   return 0;
    // }
    setRefreshPostModal(false)
    setLoaderContent((prevLoaderContent) => {
      const updatedContent = [...prevLoaderContent]; // Create a copy of the previous state array
      updatedContent[index] = { index: true, value: lodercontent }; // Update the specific element at the given index
      return updatedContent; // Return the updated array to setLoaderContent
    });
    setSelecteditem((prevState) => {
      const select = [...prevState]; // Create a copy of the array
      select[index] = item; // Set the value to true for the specified index
      return select; // Return the updated array to update the state
    });
    if (lodercontent === "Writing Social Post") {

      setRelatedpost((prevState) => {
        const select = [...prevState]; // Create a copy of the array
        select[index] = item; // Set the value to true for the specified index
        return select; // Return the updated array to update the state
      });
      settrnslateon((prevState) => {
        const select = [...prevState]; // Create a copy of the array
        select[index] = { name: "undefined", image: "undefined", description: "undefined" }; // Set the value to true for the specified index
        return select; // Return the updated array to update the state
      });
      setLastResponse((prevState) => {
        const select = [...prevState];
        if (!select[index]) {
          select[index] = {};
        }
        select[index]["socialpost"] = null;
        select[index]["tonepost"] = null;
        select[index]["transpost"] = null;
        select[index]["imgpost"] = null;
        return select;
      });
    }
    if (lodercontent === "Translating post") {
      settrnslateon((prevState) => {
        const select = [...prevState]; // Create a copy of the array
        select[index] = item; // Set the value to true for the specified index
        return select; // Return the updated array to update the state
      });
      if (lastresponse[index]?.socialpost) {
        translate_enabled(item?.name, lastresponse[index]?.socialpost, title, date, index, "socialpost")
      }
      if (lastresponse[index]?.tonepost) {
        translate_enabled(item?.name, lastresponse[index]?.tonepost, title, date, index, "tonepost")
      }
      if (lastresponse[index]?.transpost) {
        translate_enabled(item?.name, lastresponse[index]?.transpost, title, date, index, "transpost")
      }

    }
    setIsImagePrompt((prevState) => {
      const updatedIsImagePrompt = [...prevState]; // Create a copy of the array
      updatedIsImagePrompt[index] = true; // Set the value to true for the specified index
      return updatedIsImagePrompt; // Return the updated array to update the state
    });
    if (lodercontent === "Refresh Post") {

      setLastResponse((prevState) => {
        const select = [...prevState];
        if (!select[index]) {
          select[index] = {};
        }
        select[index]["socialpost"] = promptlast[index]["socialpost"];
        select[index]["tonepost"] = promptlast[index]["tonepost"];
        select[index]["transpost"] = promptlast[index]["transpost"];
        select[index]["imgpost"] = promptlast[index]["imgpost"];
        return select;
      });
      if (promptlast[index]["socialpost"]) {
        sethighlitnav((prevState) => {
          const select = [...prevState];
          if (!select[index]) {
            select[index] = {};
          }
          select[index][1] = true;
          select[index][2] = false;
          select[index][3] = false;
          select[index][4] = false;
          select[index][5] = false;
          return select;
        });
        eventContent[title] = lastresponse[index]?.socialpost;
      }
      if (promptlast[index]["socialpost"] && promptlast[index]["tonepost"]) {
        sethighlitnav((prevState) => {
          const select = [...prevState];
          if (!select[index]) {
            select[index] = {};
          }
          select[index][1] = false;
          select[index][2] = true;
          select[index][3] = false;
          select[index][4] = false;
          select[index][5] = false;
          return select;
        });
        eventContent[title] = lastresponse[index]?.tonepost;
      }
      if (promptlast[index]["transpost"] && promptlast[index]["socialpost"] && promptlast[index]["tonepost"]) {
        sethighlitnav((prevState) => {
          const select = [...prevState];
          if (!select[index]) {
            select[index] = {};
          }
          select[index][1] = false;
          select[index][2] = false;
          select[index][3] = true;
          select[index][4] = false;
          select[index][5] = false;
          return select;
        });
        eventContent[title] = lastresponse[index]?.transpost;
      }

      // if (lastresponse[index]?.socialpost && highlitnav[index][1] == true) {
      //   LoadOld_response(item?.name, promptlast[index].socialpost, title, date, index, "socialpost")
      // }

      // if (lastresponse[index]?.tonepost && highlitnav[index][2] == true) {
      //   LoadOld_response(item?.name, promptlast[index].tonepost, title, date, index, "tonepost")
      // }
      // if (lastresponse[index]?.transpost && highlitnav[index][3] == true) {
      //   LoadOld_response(item?.name, promptlast[index].transpost, title, date, index, "transpost")
      // }
      // if (lastresponse[index]?.imgpost && highlitnav[index][4] == true) {
      //   LoadOld_response(item?.name, promptlast[index].imgpost, title, date, index, "imgpost")
      // }
      return true;
    }

    handleRequest(item, title, date, index);
  };
  const translate_enabled = async (language: string, Post: string, title: string, date: string, index: number, posttype: string) => {
    setLoadingEventTitles((prevLoadingEventTitles) => ({
      ...prevLoadingEventTitles,
      [title]: true,
    }));
    const Translate = "Translate the following social media post to" + language + "." + Post + " Send only the post."
    try {
      const response: any = await generateChatContent({
        promt: Translate,
        image: false,
        profile_id: loc_id,
      });
      setEventContent((prevContent) => ({
        ...prevContent,
        [title]: response.data,
      }));


      setLoadingEventTitles((prevLoadingEventTitles) => ({
        ...prevLoadingEventTitles,
        [title]: false,
      }));
      setLastResponse((prevState) => {
        const select = [...prevState];
        if (!select[index]) {
          select[index] = {};
        }
        select[index][posttype] = response.data;
        return select;
      });
    } catch (error) {
      // Preserved from the old useHttp-based call: a failed request left
      // loadingEventTitles stuck true rather than surfacing an error UI.
    }
  }
  const LoadOld_response = async (item: string, post: string, title: string, date: string, index: number, posttype: string) => {

    setLoadingEventTitles((prevLoadingEventTitles) => ({
      ...prevLoadingEventTitles,
      [title]: true,
    }));

    try {
      const response: any = await generateChatContent({
        promt: post,
        image: false,
        profile_id: loc_id,
      });
      if (item === 'image') {
        setEventContent((prevContent) => ({
          ...prevContent,
          [title]: response.data.url,
        }));
        setImageUrl(response.data.url)
        // if (response.data.revised_prompt) {
        //   setIsImagerevisedpropmpt(response.data.revised_prompt)
        // }
      } else {
        setEventContent((prevContent) => ({
          ...prevContent,
          [title]: response.data,
        }));
      }

      setLoadingEventTitles((prevLoadingEventTitles) => ({
        ...prevLoadingEventTitles,
        [title]: false,
      }));
      setLastResponse((prevState) => {
        const select = [...prevState];
        if (!select[index]) {
          select[index] = {};
        }
        select[index][posttype] = response.data;
        return select;
      });
    } catch (error) {
      // Preserved from the old useHttp-based call: a failed request left
      // loadingEventTitles stuck true rather than surfacing an error UI.
    }
  }
  const handleMouseEnter = (type: string, title: string, date: string, index: number) => {
    if (lastresponse[index]?.socialpost) {
      eventContent[title] = lastresponse[index]?.socialpost;
      setPromptlastactive((prevState) => {
        const select = [...prevState];
        if (!select[index]) {
          select[index] = {};
        }
        select[index]["socialpost"] = "active";
        select[index]["tonepost"] = "no-active";
        select[index]["transpost"] = "no-active";
        select[index]["imgpost"] = "no-active";
        return select;
      });

      setIsImagePrompt((prevState) => {
        const updatedIsImagePrompt = [...prevState]; // Create a copy of the array
        updatedIsImagePrompt[index] = false; // Set the value to true for the specified index
        return updatedIsImagePrompt; // Return the updated array to update the state
      });
    }
    sethighlitnav((prevState) => {
      const select = [...prevState];
      if (!select[index]) {
        select[index] = {};
      }
      select[index][1] = true;
      select[index][2] = false;
      select[index][3] = false;
      select[index][4] = false;
      select[index][5] = false;
      return select;
    });
    setShowDropDown(true);
    setShowDropDown1(false);
    setShowDropDown2(false);
    setShowDropDown3(false);


  };
  const handleMouseLeave = () => {
    setShowDropDown(false);
  }
  const handleMouseEnter1 = (type: string, title: string, date: string, index: number) => {
    if (lastresponse[index]?.tonepost) {
      eventContent[title] = lastresponse[index]?.tonepost;
      setPromptlastactive((prevState) => {
        const select = [...prevState];
        if (!select[index]) {
          select[index] = {};
        }
        select[index]["socialpost"] = "no-active";
        select[index]["tonepost"] = "active";
        select[index]["transpost"] = "no-active";
        select[index]["imgpost"] = "no-active";
        return select;
      });
      setIsImagePrompt((prevState) => {
        const updatedIsImagePrompt = [...prevState]; // Create a copy of the array
        updatedIsImagePrompt[index] = false; // Set the value to true for the specified index
        return updatedIsImagePrompt; // Return the updated array to update the state
      });
    }
    sethighlitnav((prevState) => {
      const select = [...prevState];
      if (!select[index]) {
        select[index] = {};
      }
      select[index][1] = false;
      select[index][2] = true;
      select[index][3] = false;
      select[index][4] = false;
      select[index][5] = false;
      return select;
    });
    setShowDropDown(false);
    setShowDropDown1(true);
    setShowDropDown2(false);
    setShowDropDown3(false);

  };
  const handleMouseEnter2 = (type: string, title: string, date: string, index: number) => {

    if (lastresponse[index]?.imgpost) {

      eventContent[title] = lastresponse[index]?.imgpost
      setPromptlastactive((prevState) => {
        const select = [...prevState];
        if (!select[index]) {
          select[index] = {};
        }
        select[index]["socialpost"] = "no-active";
        select[index]["tonepost"] = "no-active";
        select[index]["transpost"] = "no-active";
        select[index]["imgpost"] = "active";
        return select;
      });
    }
    sethighlitnav((prevState) => {
      const select = [...prevState];
      if (!select[index]) {
        select[index] = {};
      }
      select[index][1] = false;
      select[index][2] = false;
      select[index][3] = false;
      select[index][4] = true;
      select[index][5] = false;
      return select;
    });
    setShowDropDown(false);
    setShowDropDown1(false);
    setShowDropDown2(true);
    setShowDropDown3(false);
  };
  const handleMouseEnter3 = (type: string, title: string, date: string, index: number) => {
    if (lastresponse[index]?.transpost) {
      eventContent[title] = lastresponse[index]?.transpost;
      setPromptlastactive((prevState) => {
        const select = [...prevState];
        if (!select[index]) {
          select[index] = {};
        }
        select[index]["socialpost"] = "no-active";
        select[index]["tonepost"] = "no-active";
        select[index]["transpost"] = "active";
        select[index]["imgpost"] = "no-active";
        return select;
      });
      setIsImagePrompt((prevState) => {
        const updatedIsImagePrompt = [...prevState]; // Create a copy of the array
        updatedIsImagePrompt[index] = false; // Set the value to true for the specified index
        return updatedIsImagePrompt; // Return the updated array to update the state
      });
    }
    sethighlitnav((prevState) => {
      const select = [...prevState];
      if (!select[index]) {
        select[index] = {};
      }
      select[index][1] = false;
      select[index][2] = false;
      select[index][3] = true;
      select[index][4] = false;
      select[index][5] = false;
      return select;
    });
    setShowDropDown(false);
    setShowDropDown1(false);
    setShowDropDown2(false);
    setShowDropDown3(true);
  };
  const handleMouseEnter4 = (index: number) => {
    sethighlitnav((prevState) => {
      const select = [...prevState];
      if (!select[index]) {
        select[index] = {};
      }
      select[index][1] = false;
      select[index][2] = false;
      select[index][3] = false;
      select[index][4] = false;
      select[index][5] = true;
      return select;
    });
    handleMouseLeaveall();
  }
  const handleMouseLeaveall = () => {
    setShowDropDown(false);
    setShowDropDown1(false);
    setShowDropDown2(false);
    setShowDropDown3(false);
  }
  const getFileNameFromUrl = (url: string) => {
    // Split the URL by '/'
    const parts = url.split('/');
    // Get the last part which is the filename
    const filename = parts[parts.length - 1];
    return filename;
  };
  const handleDownloadClick = async (url: string) => {
    try {
      const filename = getFileNameFromUrl(url);

      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = filename;
      anchor.click();

      URL.revokeObjectURL(anchor.href);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const [openModelCelender, setopenModelCelender] = useState(false)
  const [openPostModel, setOpenPostModel] = useState(false)
  const [postSummary, setPostSummary] = useState<string | null>();
  const [postTitle, setPostTitle] = useState<string | null>();
  const [isScheduling, setIsScheduling] = useState(false);
  const [accountErr, setAccountErr] = useState<boolean | null>();
  const [dateErr, setDateErr] = useState<boolean | null>();
  const [posting, setPosting] = useState<boolean>(false);
  const [postSuccess, setPostSuccess] = useState<boolean>(false);
  const [selectedIndex, setSelectedIndex] = useState<any>()

  const findImageByTitle = (title: any) => {
    const foundImage = eventImages.find((image: any) => Object.keys(image)[0] === title);
    return foundImage ? foundImage[title] : null;
  };

  const handlePostOnGHl = (title: string, summary: any, index: number, shcedule: boolean) => {
    if (!findImageByTitle(title) && Relatedpost[index].name.toLowerCase() === "instagram") {
      setopenimginfoModal(true)
      return 0;
    }
    const summaryryy = summary.includes("https://statictemp");
    if (summaryryy) {
      setPostSummary(lastresponse[index]?.socialpost);
    } else {
      setPostSummary(summary);
    }
    setIsScheduling(shcedule);
    setPostTitle(title);
    setOpenPostModel(true);
    setPostSuccess(false)
    setDateErr(false)
    setAccountErr(false);
    setSelectedIndex(index);
  }
  const for_OpenCelander = (index: number) => {
    setopenModelCelender(true)
  }
  const handlePosting = async (e: any) => {
    e.preventDefault();
    setPosting(true)
    setAccountErr(false)
    setDateErr(false)
    if (!e.target?.account?.value) {
      setAccountErr(true);
      setPosting(false)
      return false
    }

    if (e.target?.schedule_date?.value !== undefined && e.target?.schedule_date?.value === '') {
      setDateErr(true);
      setPosting(false)
      return false
    }

    const payload = {
      media: findImageByTitle(postTitle),
      location_id: userActiveLocation?.id,
      account_id: e.target?.account?.value,
      sch_date: e.target?.schedule_date?.value !== undefined ? e.target?.schedule_date?.value : '',
      summary: postSummary,
      title: postTitle
    }

    try {
      const response = await postOnGhlMutation.mutateAsync(payload)
      if (response) {
        setPosting(false);
        setPostSuccess(true);
        setAccountErr(false)
        setDateErr(false)
        e.target.account.value = '';
        e.target.schedule_date.value = '';
      }
    } catch (error) {
      setPosting(false);
    }
  }

  return (
    <div className="mt-8 flex flex-wrap ">
      <div
        className="dayDate flex flex-col items-start mb-4 w-[5%]"
        id={currentDate.toString() == dayOfMonth.toString() ? "focus" : ""}
      >
        <h2>{dayOfMonth}</h2>
        <p>{dayOfWeek.toUpperCase()}</p>
      </div>
      <div className="dayEvents  w-[95%] ">
        {events.length > 0 ? (
          <div className="flex flex-wrap w-full ">
            {events.map((event, index) => (
              <div key={index} className="w-full md:w-1/3 mb-4 p-5 pt-0 pl-0">
                <div className="eventBoxWrapper my-7 p-5" style={{ margin: "5px 10px 40px 10px" }} >
                  {loadingEventTitles[event.title] && (
                    <>
                      <div className="loadingReq text-center ">
                        <h4>
                          <span className="flip-emoji">✍️</span>
                          <span className="flip-emoji">😃</span>
                        </h4>
                        <p className="typing-text">
                          {LoaderContent[index]?.value}
                          <span className="dot">.</span>
                          <span className="dot">.</span>
                          <span className="dot">.</span>
                        </p>
                        <p className="sociallistbg">
                          Did you know you can translate your post to over 20+ languages?
                        </p>
                      </div>

                    </>
                  )}
                  <div className="eventBox my-5 px-5 flex flex-col justify-between h-full">
                    <div className="dayMetaInfo">
                      <h2 className="eventTitle mb-3">{event.title}</h2>
                      <p className={`${loadingEventTitles[event.title] === undefined ? "" : "eventboxwraperresponsebox"} eventContent p-5`}>
                        {loadingEventTitles[event.title] ? (
                          "Loading..."
                        ) : (
                          (<>
                            {eventContent[event.title]?.includes("https://statictemp") ?
                              <img src={eventContent[event.title]} />
                              :
                              <>
                                <div className="eventContent" style={{ display: "flex", width: "100%" }}>
                                  <div style={{ width: "10%", paddingTop: "5px" }}>
                                    <img src={Relatedpost[index]?.image} alt={Relatedpost[index]?.image} width={"50px"} />
                                  </div>
                                  <div style={{ width: "90%", paddingLeft: "5px" }} dangerouslySetInnerHTML={{
                                    __html: eventContent[event.title] || "",
                                  }} />
                                </div>
                              </>
                            }

                          </>
                          )
                        )}
                        <div className={`${loadingEventTitles[event.title] === undefined ? "d-none" : "d-block"} text-right relative`}>
                          {!eventContent[event.title]?.includes("https://statictemp") && (
                            <button
                              className="copyContent"
                              onMouseEnter={() => setShowTooltip(index)}
                              onMouseLeave={() => setShowTooltip(null)}
                              onClick={() => copyEventContent(eventContent[event.title], index)}
                            >
                              <SvgIcon id={"copy"} />
                              {showTooltip === index && (
                                <div className="toolTipBox" style={{ position: "absolute", top: "-30px" }}>
                                  {tooltipStates[index] || "Copy!"}
                                </div>
                              )}
                            </button>
                          )}
                        </div>
                      </p>
                      {eventContent[event.title] === undefined && (
                        <p className="eventHashtag" >{event.hashtags}</p>
                      )}
                    </div>
                    <div className="dayActions my-5">
                      {eventContent[event.title] === undefined ? (
                        <div>
                          <button
                            className="writePost"
                            onMouseEnter={() => handleMouseEnter("socialpost", event.title, event.date, index)}
                          >
                            <SvgIcon id={"stars"} />
                            Write me a Post
                          </button>
                          {showDropDown && (
                            <div className="dropdown pt-1" >

                              <ul onMouseLeave={handleMouseLeaveall} style={{ maxHeight: "150px", zIndex: "+9999", overflowY: "scroll" }} className="dropdown-menu" aria-labelledby="dropdownMenuButton1">

                                {socialopt?.map((item: any, indexes: number) => (
                                  <li key={indexes}
                                    onClick={() => { handleBoxClickforModal("Writing Social Post", item, event.title, event.date, index); handleMouseLeave() }}>
                                    <a className="dropdown-item" style={{ display: "flex" }}>
                                      <img src={item?.image} /> <span className="px-2">{item.name}</span>
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="py-2">
                          {eventContent[event.title]?.includes("https://statictemp") ?
                            <button
                              className="writePost w-full"
                              onClick={() => { handleDownloadClick(eventContent[event.title]) }}
                            >
                              Download
                            </button> : <>
                            </>}
                          <div className="flex justify-between pt-8 pb-0 mb-0 relative">
                            <span className={`${highlitnav[index]?.[1] ? "activedata" : ""}`}
                              onClick={() => handleMouseEnter("socialpost", event.title, event.date, index)}

                            ><Firstoption width="36" height="36" /></span>
                            {showDropDown && (
                              <div className="dropdown" style={{ position: "absolute", left: 0, top: 75 }}>

                                <ul onMouseLeave={handleMouseLeave} style={{ maxHeight: "150px", zIndex: "+9999", overflowY: "scroll" }} className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                  <li>
                                    <p className="chanelheading">Change Channel...</p>
                                  </li>
                                  {socialopt.map((item: any, indexes: number) => (
                                    <li key={indexes} onClick={() => { handleBoxClickforModal("Writing Social Post", item, event.title, event.date, index); handleMouseLeave() }}>
                                      <a className="dropdown-item" style={{ display: "flex" }}>
                                        <img src={item?.image} /> <span className="px-2">{item.name}</span>
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                            {checkIfGhlUser && <>
                              <div onClick={() => handlePostOnGHl(event.title, eventContent[event.title], index, false)}>
                                <SendIcon width="36" height="36" />
                              </div>
                              <div onClick={() => handlePostOnGHl(event.title, eventContent[event.title], index, true)}>
                                <CelenderIcon width="36" height="36" />
                              </div>
                            </>}

                            <div className={`${highlitnav[index]?.[2] ? "activedata" : ""} relative`}>
                              <span

                                onClick={() => handleMouseEnter1("tonepost", event.title, event.date, index)} ><SmileIcon width="36" height="36" /></span>
                              {showDropDown1 && (
                                <div className="dropdown" style={{ position: "absolute", left: 0, top: 40 }}>

                                  <ul style={{ maxHeight: "150px", zIndex: "+9999", overflowY: "scroll" }} onMouseLeave={handleMouseLeaveall} className="dropdown-menu" aria-labelledby="dropdownMenuButton1">

                                    {tonesopt.map((item, indexes) => (
                                      <li key={indexes} onClick={() => { handleBoxClickforModal("Editing post", item, event.title, event.date, index); handleMouseLeave() }}>
                                        <a className="dropdown-item">
                                          {item.name}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                            <div className={`${highlitnav[index]?.[3] ? "activedata" : ""} relative`}>
                              <span onClick={() => handleMouseEnter3("transpost", event.title, event.date, index)} ><TranslateIcon width="36" height="36" /></span>
                              {showDropDown3 && (
                                <div className="dropdown" style={{ position: "absolute", left: 0, top: 40, zIndex: "+99999999" }}>
                                  <ul style={{ maxHeight: "150px", zIndex: "+9999", overflowY: "scroll" }} onMouseLeave={handleMouseLeaveall} className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    {translateopt.map((item, indexes) => (
                                      <li key={indexes} onClick={() => { handleBoxClickforModal("Translating post", item, event.title, event.date, index); handleMouseLeaveall() }}>
                                        <a className="dropdown-item">
                                          {item.name}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                            <div className={`${highlitnav[index]?.[4] ? "activedata" : ""} relative`}>
                              <span onClick={() => handleMouseEnter2("imgpost", event.title, event.date, index)}  ><ThumbnailIcon width="36" height="36" /></span>
                              {showDropDown2 && (
                                <div className="dropdown" style={{ position: "absolute", left: 0, top: 40 }}>

                                  <ul style={{ maxHeight: "150px", zIndex: "+9999", overflowY: "scroll" }} onMouseLeave={handleMouseLeaveall} className="dropdown-menu" aria-labelledby="dropdownMenuButton1">

                                    {imagesoption.map((item, indexes) => (

                                      <li key={indexes} onClick={() => { handleRequestfirstloadimageonly("Creating image", item, event.title, event.date, index); handleMouseLeaveall() }}>
                                        <a className="dropdown-item">
                                          {item.name}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>

                            <span className={`${highlitnav[index]?.[5] ? "activedata" : ""}`}
                              onMouseEnter={() => { handleMouseLeaveall() }}
                              onClick={() => { handleBoxClick("Refresh Post", selecteditem[index], event.title, event.date, index) }}
                            ><RestartIcon width="36" height="36" /></span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div></div>
        )}
        {openimginfoModal &&
          <>
            <div className="modal-zz" style={{ zIndex: '9999' }}>
              <div className="modal-content-zz position-relative fitContentHeight" style={{ maxHeight: "fit-content", height: 'fit-content' }} onClick={(e) => e.stopPropagation()}>
                <h1 className="text-center chanelheading">To publish on Instagram you must have to create the image as well.</h1>
                <button style={{ width: "100%", background: "#000", color: '#fff', fontSize: '20px', borderRadius: "6px", padding: "8px 0" }} color="info" className="writePost" onClick={() => setopenimginfoModal(false)}>Alright</button>
                <div>
                </div>
              </div>
            </div>
          </>
        }
        {RefreshPostModal && <>
          <div className="modal-zz" onClick={() => setRefreshPostModal(false)}>
            <div className="modal-content-zz position-relative" style={{ maxHeight: "350px" }} onClick={(e) => e.stopPropagation()}>
              <p
                style={{
                  position: "absolute",
                  right: 5,
                  width: "12px",
                  top: "10px",
                  height: "12px",
                  cursor: "pointer",
                }}
                onClick={() => setRefreshPostModal(false)}
              >
                X
              </p>
              <h1 className="text-center chanelheading">Are You Sure You Want to Create New Post?</h1>
              <p className="text-center">Copy your Current Post to avoid losing your changes. </p>
              <div>
                <p className="copybutton" onClick={() => copyEventContent(RefreshPostModaldata.copyresponse, RefreshPostModaldata.index)}>Copy Current Post</p>
                <p className="createbutton" onClick={() => handleBoxClick(RefreshPostModaldata.lodercontent, RefreshPostModaldata.item, RefreshPostModaldata.title, RefreshPostModaldata.date, RefreshPostModaldata.index)}>Create a new Post</p>
              </div>
            </div>
          </div>
        </>}
      </div>
      {openModelCelender && <>

        <div className="modal-zz" onClick={() => setopenModelCelender(false)}>
          <div className="modal-content-zz position-relative" onClick={(e) => e.stopPropagation()}>
            <p
              style={{
                position: "absolute",
                right: 5,
                width: "12px",
                top: "10px",
                height: "12px",
                cursor: "pointer",
              }}
              onClick={() => setopenModelCelender(false)}
            >
              X
            </p>


            <div className="text-center">
              <div style={{ width: "100%" }}>
                <DateRange
                  editableDateInputs={true}
                  ranges={celenderdate}
                  onChange={handleSelect}
                  moveRangeOnFirstSelection={false}
                // months={2}
                // direction="horizontal"

                />
              </div>
              <div>
                <p>Start Date: {celenderdate[0].startDate.toDateString()}</p>
                <p>End Date: {celenderdate[0].endDate.toDateString()}</p>
              </div>
            </div>
          </div>
        </div>
      </>}
      {openPostModel && <>
        <div className="postOnGhlWrap" onClick={() => setOpenPostModel(false)}>
          <div className="contentHolder position-relative" onClick={(e) => e.stopPropagation()}>
            <div className="form-wrapper border-main previewPostWrapper" style={{ maxWidth: '700px' }}>
              <div style={{ position: 'relative' }} className="previewFormHolder">
                <span onClick={() => setOpenPostModel(false)} style={{ position: 'absolute', left: '-15px', top: '-20px', cursor: 'pointer' }}><SvgIcon id={'close'} /></span>
                <h2>Choose an account and publish post.</h2>
                {postSuccess && (
                  <small style={{ color: 'green' }}>Post created successfully</small>
                )}
                <form className="postOnGhlForm" onSubmit={handlePosting}>
                  <div className="mb-2">
                    <select name="account" id="account">
                      <option value="" selected>Select an account!</option>
                      {SMAccoutns && SMAccoutns?.filter((item) => item.platform === Relatedpost[selectedIndex].name.toLowerCase())?.map((item: any, index: number) => (
                        <option value={item.id}>{item.name} ({item.platform})</option>
                      ))}
                    </select>
                    {accountErr && (
                      <small style={{ color: 'red' }}>Please select an account!</small>
                    )}
                  </div>

                  {isScheduling && (
                    <div className="mb-2">
                      <input type="datetime-local" name="schedule_date" placeholder="Select Date" />
                      {dateErr && (
                        <small style={{ color: 'red' }}>Please select schedule date!</small>
                      )}
                    </div>
                  )}

                  <div className="mt-5" style={{ textAlign: "right" }}>
                    <button style={{ width: "100%" }} color="info" type="submit" disabled={posting}>
                      {posting && (<SvgIcon id={'spinner'} color={'#fff'} />)}
                      Publish
                    </button>
                  </div>
                </form>
              </div>
              <div style={{ position: 'relative', height: '500px', 'overflow': 'auto' }} className="previewPostHolder">
                <img src={findImageByTitle(postTitle)} alt="" />
                <p>{postSummary}</p>
              </div>
            </div>
          </div>
        </div>
      </>}
    </div>
  );
};



const Linkdin = (...props: any) => {
  return (<svg width={props[0].width} height={props[0].height} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="23" height="23" rx="5" fill="#0077B5" />
    <g clipPath="url(#clip0_162_1274)">
      <path d="M8.71666 15.6073H6.72983V9.20916H8.71666V15.6073ZM7.72218 8.33639C7.08685 8.33639 6.57153 7.81017 6.57153 7.17484C6.57153 6.86967 6.69276 6.577 6.90855 6.36122C7.12434 6.14543 7.41701 6.0242 7.72218 6.0242C8.02734 6.0242 8.32001 6.14543 8.5358 6.36122C8.75159 6.577 8.87282 6.86967 8.87282 7.17484C8.87282 7.81017 8.35728 8.33639 7.72218 8.33639ZM16.1527 15.6073H14.1702V12.4927C14.1702 11.7505 14.1552 10.7985 13.1372 10.7985C12.1042 10.7985 11.9459 11.605 11.9459 12.4393V15.6073H9.96121V9.20916H11.8668V10.0819H11.8946C12.1598 9.57923 12.8078 9.04873 13.7744 9.04873C15.7852 9.04873 16.1549 10.3729 16.1549 12.0927V15.6073H16.1527Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_162_1274">
        <rect width="9.58333" height="10.9524" fill="white" transform="translate(6.57153 6.0238)" />
      </clipPath>
    </defs>
  </svg>)
}
const TwitterIcon = (...props: any) => {
  return (
    <img src={Twiterimg} width={props[0].width} height={props[0].height} />

  )
}
const Instagram = (...props: any) => {
  return (<svg width={props[0].width} height={props[0].height} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="23" height="22" rx="5" fill="#BA4593" />
    <g clipPath="url(#clip0_162_1267)">
      <path d="M16.9656 9.36573C16.94 8.80909 16.8459 8.42641 16.7111 8.09481C16.572 7.74282 16.358 7.42769 16.0777 7.16571C15.8038 6.89966 15.4722 6.69293 15.1085 6.56199C14.7598 6.43304 14.3618 6.34302 13.7799 6.31848C13.1936 6.29186 13.0075 6.28571 11.5205 6.28571C10.0335 6.28571 9.84735 6.29186 9.26324 6.3164C8.6813 6.34095 8.28122 6.43104 7.93463 6.55991C7.56656 6.69293 7.2371 6.89759 6.96322 7.16571C6.68508 7.42769 6.46903 7.7449 6.33205 8.09281C6.19724 8.42641 6.10314 8.80702 6.07748 9.36366C6.04965 9.92445 6.04321 10.1025 6.04321 11.5248C6.04321 12.9472 6.04965 13.1252 6.07531 13.6839C6.10096 14.2406 6.19515 14.6232 6.32996 14.9548C6.46903 15.3068 6.68508 15.622 6.96322 15.8839C7.2371 16.15 7.56873 16.3567 7.93245 16.4877C8.28122 16.6166 8.67913 16.7066 9.26115 16.7312C9.84518 16.7558 10.0314 16.7619 11.5184 16.7619C13.0054 16.7619 13.1915 16.7558 13.7756 16.7312C14.3575 16.7066 14.7576 16.6166 15.1042 16.4877C15.8403 16.2155 16.4222 15.6588 16.7068 14.9548C16.8415 14.6212 16.9357 14.2406 16.9614 13.6839C16.987 13.1252 16.9935 12.9472 16.9935 11.5248C16.9935 10.1025 16.9913 9.92445 16.9656 9.36573ZM15.9793 13.643C15.9558 14.1546 15.8659 14.4309 15.791 14.6151C15.607 15.0715 15.2283 15.4337 14.7512 15.6097C14.5586 15.6814 14.2677 15.7673 13.7349 15.7898C13.1572 15.8144 12.984 15.8205 11.5226 15.8205C10.0613 15.8205 9.88588 15.8144 9.31029 15.7898C8.77541 15.7673 8.48657 15.6814 8.29401 15.6097C8.05657 15.5258 7.84044 15.3928 7.66501 15.2188C7.48315 15.0489 7.34408 14.8443 7.25632 14.6172C7.18144 14.433 7.09159 14.1546 7.06811 13.6451C7.04237 13.0925 7.03602 12.9267 7.03602 11.5289C7.03602 10.1311 7.04237 9.96331 7.06811 9.41282C7.09159 8.90119 7.18144 8.62491 7.25632 8.44072C7.34408 8.21352 7.48315 8.00687 7.66718 7.83899C7.8447 7.66504 8.05866 7.53201 8.29618 7.44815C8.48874 7.37652 8.77975 7.29058 9.31247 7.26804C9.89015 7.2435 10.0635 7.23734 11.5247 7.23734C12.9882 7.23734 13.1615 7.2435 13.7371 7.26804C14.272 7.29058 14.5608 7.37652 14.7534 7.44815C14.9908 7.53201 15.2069 7.66504 15.3824 7.83899C15.5642 8.00887 15.7033 8.21352 15.791 8.44072C15.8659 8.62491 15.9558 8.90319 15.9793 9.41282C16.005 9.96538 16.0114 10.1311 16.0114 11.5289C16.0114 12.9267 16.005 13.0904 15.9793 13.643Z" fill="white" />
      <path d="M11.5205 8.83362C9.96728 8.83362 8.70703 10.039 8.70703 11.5248C8.70703 13.0106 9.96728 14.216 11.5205 14.216C13.0739 14.216 14.3341 13.0106 14.3341 11.5248C14.3341 10.039 13.0739 8.83362 11.5205 8.83362ZM11.5205 13.2705C10.5129 13.2705 9.69549 12.4888 9.69549 11.5248C9.69549 10.5609 10.5129 9.7791 11.5205 9.7791C12.5283 9.7791 13.3456 10.5609 13.3456 11.5248C13.3456 12.4888 12.5283 13.2705 11.5205 13.2705Z" fill="white" />
      <path d="M15.1021 8.72724C15.1021 9.07419 14.808 9.35551 14.4452 9.35551C14.0824 9.35551 13.7883 9.07419 13.7883 8.72724C13.7883 8.38021 14.0824 8.09897 14.4452 8.09897C14.808 8.09897 15.1021 8.38021 15.1021 8.72724Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_162_1267">
        <rect width="10.9524" height="10.4762" fill="white" transform="translate(6.02393 6.28571)" />
      </clipPath>
    </defs>
  </svg>
  );
}
const Firstoption = (...props: any) => {
  return (<svg width={props[0].width} height={props[0].height} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.4615 18.6136H2.82051C2.3959 18.6136 2.05128 18.9583 2.05128 19.3829C2.05128 19.8075 2.3959 20.1521 2.82051 20.1521H18.9744C19.518 20.1521 20 19.67 20 19.1265V2.97261C20 2.548 19.6554 2.20338 19.2308 2.20338C18.8062 2.20338 18.4615 2.548 18.4615 2.97261V18.6136ZM17.4359 1.17774C17.4359 0.687484 17.0472 0.1521 16.4103 0.1521H1.02564C0.389744 0.1521 0 0.684407 0 1.17774V16.5624C0 17.1993 0.533333 17.588 1.02564 17.588H16.4103C16.9005 17.588 17.4359 17.1993 17.4359 16.5624V1.17774ZM7.94872 8.10082V5.02389C7.94872 4.59928 8.29333 4.25466 8.71795 4.25466C9.14256 4.25466 9.48718 4.59928 9.48718 5.02389V8.10082H12.5641C12.9887 8.10082 13.3333 8.44543 13.3333 8.87005C13.3333 9.29466 12.9887 9.63928 12.5641 9.63928H9.48718V12.7162C9.48718 13.1408 9.14256 13.4854 8.71795 13.4854C8.29333 13.4854 7.94872 13.1408 7.94872 12.7162V9.63928H4.8718C4.44718 9.63928 4.10256 9.29466 4.10256 8.87005C4.10256 8.44543 4.44718 8.10082 4.8718 8.10082H7.94872Z" fill="#757575" />
  </svg>

  );
}
const FacebookIcon = (...props: any) => {
  return (
    <svg width={props[0].width} height={props[0].height} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="23" height="22" rx="5" fill="#36609F" />
      <g clipPath="url(#clip0_162_1260)">
        <path d="M13.3242 8.02519H14.3241V6.35948C14.1516 6.33678 13.5583 6.28571 12.8674 6.28571C11.4258 6.28571 10.4382 7.15305 10.4382 8.74717V10.2143H8.84741V12.0764H10.4382V16.7619H12.3887V12.0769H13.9152L14.1575 10.2147H12.3882V8.93182C12.3887 8.3936 12.5402 8.02519 13.3242 8.02519Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_162_1260">
          <rect width="10.9524" height="10.4762" fill="white" transform="translate(6.02393 6.28571)" />
        </clipPath>
      </defs>
    </svg>

  );
}
const CelenderIcon = (...props: any) => {
  return (
    <svg width={props[0].width} height={props[0].height} viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.7779 3.21875H3.22222C1.99492 3.21875 1 4.21367 1 5.44098V20.9966C1 22.2239 1.99492 23.2188 3.22222 23.2188H18.7779C20.0052 23.2188 21 22.2239 21 20.9966V5.44098C21 4.21367 20.0052 3.21875 18.7779 3.21875Z" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15.4443 1V5.44446" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6.55615 1V5.44446" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M1 9.8855H21" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>


  );
}
const SendIcon = (...props: any) => {
  return (
    <svg width={props[0].width} height={props[0].height} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.15586 9.57417C0.747209 9.77849 0.804084 10.3787 1.24384 10.5026L8.86063 12.6492C9.04738 12.7018 9.2477 12.6417 9.37457 12.4949L12.403 8.99053C12.7875 8.54564 12.222 7.91739 11.7392 8.2531L8.39646 10.5778C8.27414 10.6629 8.12025 10.6889 7.97673 10.6489L5.8602 10.0589C5.41941 9.93606 5.36158 9.33469 5.77087 9.13007L16.4114 3.81048C16.798 3.61722 17.2311 3.97232 17.1174 4.38927L14.3123 14.6737C14.2146 15.0318 13.7746 15.1624 13.4974 14.9156L11.3833 13.0332C11.1639 12.8378 10.8243 12.8728 10.6493 13.1087L9.47197 14.6956C9.37475 14.8266 9.16667 14.7579 9.16667 14.5947C9.16667 14.5188 9.11612 14.4521 9.043 14.4316L8.13482 14.1773C7.81599 14.0881 7.5 14.3277 7.5 14.6588V18.6386C7.5 19.1205 8.11455 19.3235 8.4016 18.9365L10.9018 15.5655C11.0768 15.3295 11.4165 15.2945 11.6359 15.4899L14.3974 17.9489C14.6746 18.1957 15.1146 18.0651 15.2123 17.707L19.7058 1.23099C19.8195 0.81402 19.3863 0.458932 18.9998 0.652215L1.15586 9.57417Z" fill="#757575" />
    </svg>



  );
}
const SmileIcon = (...props: any) => {
  return (
    <svg width={props[0].width} height={props[0].height} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 1.81877C14.595 1.81877 18.3333 5.5571 18.3333 10.1521C18.3333 14.7471 14.595 18.4854 10 18.4854C5.405 18.4854 1.66667 14.7471 1.66667 10.1521C1.66667 5.5571 5.405 1.81877 10 1.81877ZM10 0.1521C4.4775 0.1521 0 4.6296 0 10.1521C0 15.6746 4.4775 20.1521 10 20.1521C15.5225 20.1521 20 15.6746 20 10.1521C20 4.6296 15.5225 0.1521 10 0.1521ZM14.5892 11.7696C13.3292 12.7654 11.9442 13.3788 10.0008 13.3788C8.05583 13.3788 6.67083 12.7654 5.41083 11.7696L5 12.1804C5.93917 13.6138 7.66667 15.1521 10.0008 15.1521C12.3342 15.1521 14.0608 13.6138 15 12.1804L14.5892 11.7696ZM7.08333 6.81877C6.39333 6.81877 5.83333 7.37793 5.83333 8.06877C5.83333 8.7596 6.39333 9.31877 7.08333 9.31877C7.77333 9.31877 8.33333 8.7596 8.33333 8.06877C8.33333 7.37793 7.77333 6.81877 7.08333 6.81877ZM12.9167 6.81877C12.2267 6.81877 11.6667 7.37793 11.6667 8.06877C11.6667 8.7596 12.2267 9.31877 12.9167 9.31877C13.6067 9.31877 14.1667 8.7596 14.1667 8.06877C14.1667 7.37793 13.6067 6.81877 12.9167 6.81877Z" fill="#757575" />
    </svg>



  );
}
const ThumbnailIcon = (...props: any) => {
  return (
    <svg width={props[0].width} height={props[0].height}
      viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.6848 8.17924C14.3631 7.69681 13.6511 7.70606 13.3422 8.19669L11.9554 10.3988C11.702 10.8012 11.1556 10.895 10.7825 10.6003L9.65708 9.71119C9.29914 9.42842 8.77758 9.50171 8.51143 9.87218L4.91003 14.8853C4.5298 15.4146 4.90806 16.1521 5.55975 16.1521H18.5052C19.1441 16.1521 19.5253 15.44 19.1708 14.9083L14.6848 8.17924ZM21.2 2.1521C21.6418 2.1521 22 2.51027 22 2.9521V17.3521C22 17.7939 21.6418 18.1521 21.2 18.1521H2.8C2.35817 18.1521 2 17.7939 2 17.3521V2.9521C2 2.51027 2.35817 2.1521 2.8 2.1521H21.2ZM24 0.952099C24 0.510271 23.6418 0.1521 23.2 0.1521H0.799999C0.358171 0.1521 0 0.510272 0 0.9521V19.3521C0 19.7939 0.358172 20.1521 0.8 20.1521H23.2C23.6418 20.1521 24 19.7939 24 19.3521V0.952099ZM4 6.1521C4 5.0481 4.896 4.1521 6 4.1521C7.104 4.1521 8 5.0481 8 6.1521C8 7.2571 7.104 8.1521 6 8.1521C4.896 8.1521 4 7.2571 4 6.1521Z" fill="#757575" />
    </svg>

  );
}
const TranslateIcon = (...props: any) => {
  return (
    <svg width={props[0].width} height={props[0].height} viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.23727 6.06119H8.42182L10.6673 11.9703H9.44091L8.95182 10.6066H6.73546L6.24909 11.9703H4.98364L7.23727 6.06119ZM8.61636 9.66574L7.83727 7.43755L7.06364 9.66574H8.61636ZM15.9727 8.39119C16.0291 8.17028 16.0636 8.00392 16.0955 7.84119L15.0955 7.64665L14.9964 8.10119C14.6591 8.0521 14.2991 8.04574 13.9364 8.0821C13.9445 7.83846 13.9591 7.59937 13.9809 7.36937H15.0982V6.4221H14.1155C14.1645 6.18119 14.2055 6.03665 14.2464 5.89937L13.27 5.60665C13.1982 5.84574 13.1382 6.08028 13.0782 6.4221H11.9636V7.36937H12.9564C12.9309 7.67574 12.9145 7.99301 12.91 8.31301C11.8127 8.71574 11.3473 9.48392 11.3473 10.1803C11.3473 11.0021 11.9964 11.7257 13.0218 11.633C14.2955 11.5166 15.1464 10.5548 15.6445 9.3721C16.16 9.66937 16.3764 10.1685 16.1818 10.6312C16.0027 11.0594 15.4727 11.4666 14.4618 11.4457V12.4648C15.5836 12.4821 16.6873 12.0557 17.1209 11.0257C17.5436 10.0185 17.0609 8.91846 15.9727 8.39119ZM14.6582 9.08755C14.4991 9.43937 14.2909 9.78846 14.0245 10.0648C13.9836 9.77119 13.9555 9.45028 13.94 9.10665C14.1836 9.07483 14.4282 9.06937 14.6582 9.08755ZM12.9364 9.41665C12.9636 9.84665 13.0127 10.243 13.08 10.5966C12.1736 10.763 12.1373 9.86846 12.9364 9.41665ZM10.9091 1.97028C15.9218 1.97028 20 5.23574 20 9.24937C20 13.7194 15.3227 16.4866 10.9909 16.4866C9.23 16.4866 7.91455 16.1257 6.99636 15.9012C6.08727 16.4585 5.54727 16.8439 3.11273 17.5557C3.59909 16.3076 3.76909 15.0576 3.65909 13.6785C2.89818 12.7694 1.81818 11.4966 1.81818 9.24937C1.81818 5.23574 5.89636 1.97028 10.9091 1.97028ZM10.9091 0.1521C5.14727 0.1521 0 3.99392 0 9.24937C0 11.113 0.671818 12.943 1.86091 14.363C1.91091 16.0266 0.930909 18.4139 0.0490909 20.1521C2.41455 19.7248 5.77727 18.7812 7.30182 17.8466C8.59 18.1603 9.82364 18.3039 10.9918 18.3039C17.4309 18.3039 21.8191 13.9066 21.8191 9.24846C21.8182 3.96574 16.6355 0.1521 10.9091 0.1521Z" fill="#757575" />
    </svg>



  );
}
const RestartIcon = (...props: any) => {
  return (
    <svg width={props[0].width} height={props[0].height} viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.50338 4.87928C4.26882 2.04257 7.4156 0.1521 11.0005 0.1521C16.5199 0.1521 21 4.63322 21 10.1516C21 15.672 16.5199 20.1531 11.0005 20.1531C5.75419 20.1531 1.44511 16.1041 1.03201 10.9628C1.008 10.6607 1.22106 10.1516 1.7812 10.1516C2.17229 10.1516 2.49637 10.4517 2.52838 10.8418C2.87947 15.2119 6.54139 18.6527 11.0005 18.6527C15.6917 18.6527 19.4996 14.8438 19.4996 10.1516C19.4996 5.46143 15.6917 1.65247 11.0005 1.65247C7.96274 1.65247 5.29507 3.24987 3.7927 5.64847L5.7842 5.65348C6.1983 5.65348 6.53438 5.98956 6.53438 6.40366C6.53438 6.81777 6.1983 7.15385 5.7842 7.15385H1.75019C1.33608 7.15385 1 6.81777 1 6.40366V2.35365C1 1.93955 1.33608 1.60346 1.75019 1.60346C2.16429 1.60346 2.50038 1.93855 2.50038 2.35365L2.50338 4.87928Z" fill="#757575" stroke="#757575" stroke-width="0.25" />
    </svg>


  );
}